import { AdvancedFiltersCustomFieldsController } from './advanced-filters-custom-fields.controller'

function advancedFiltersCustomFields () {
  return {
    restrict: 'E',
    scope: {
      form: '<'
    },
    templateUrl: '/core/directives/advanced-filters-custom-fields/advanced-filters-custom-fields.html?$$REVISION$$',
    controller: AdvancedFiltersCustomFieldsController
  }
}
export { advancedFiltersCustomFields }
